import { Link } from 'react-router-dom';
import categories from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section id="categories" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
            <i className="ri-layout-grid-line" aria-hidden="true"></i>
            SWEET CATEGORIES
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">按心情挑一片瓜田</h2>
          <p className="mt-3 text-sm text-foreground-600">
            想被暖到就去恋爱小料，想心跳漏拍就翻心动瞬间，想看别人幸福就进官宣现场。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/fresh?category=${cat.slug}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full h-40 overflow-hidden bg-background-200">
                <img
                  src={cat.cover}
                  alt={`${cat.name}分类封面`}
                  title={`${cat.name} - 糖心吃瓜`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute left-3 top-3 w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-600">
                  <i className={`${cat.icon} text-lg`} aria-hidden="true"></i>
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{cat.count} 条</span>
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}